export default {
    gray: "#EDEDED",
    grayDark: "#DBDBDB",
    red: "#F07480",
    redDark: "#E85361",
    green: "#008000",
    blue: "#5A87E5"
};